module.exports = __webpack_public_path__ + "static/media/2-nebula.d89d1ff7.png";